<template>
	<div class="ryodoraku-results">
		<!-- <v-row no-gutters v-if="clinic">
			<v-col cols="12" md="12" style="height: 300px">
				<GChart type="ComboChart" :data="mainChartData" :options="mainChartOptions" />
			</v-col>
			<v-col v-if="showGCharts" cols="12">
				<v-row no-gutters>
					<v-col>
						<v-row no-gutters justify="center">
						<b>M G</b>
						<GChart
							:settings="{ packages: ['gauge'] }"
							type="Gauge"
							:data="ratio0aChartData"
							:options="ratio0aChartOptions"
						/>
						</v-row>
					</v-col>
					<v-col>
						<v-row no-gutters justify="center">
						<b>I A E</b>
						<GChart
							:settings="{ packages: ['gauge'] }"
							type="Gauge"
							:data="ratio0bChartData"
							:options="ratio0bChartOptions"
						/>
						</v-row>
					</v-col>
					<v-col>
						<v-row no-gutters justify="center">
						<b>R M-E</b>
						<GChart
							:settings="{ packages: ['gauge'] }"
							type="Gauge"
							:data="ratio1ChartData"
							:options="ratio1ChartOptions"
						/>
						</v-row>
					</v-col>
					<v-col>
						<v-row no-gutters justify="center">
						<b>R M</b>
						<GChart
							:settings="{ packages: ['gauge'] }"
							type="Gauge"
							:data="ratio2ChartData"
							:options="ratio2ChartOptions"
						/>
						</v-row>
					</v-col>
					<v-col>
						<v-row no-gutters justify="center">
						<b>R C/M</b>
						<GChart
							:settings="{ packages: ['gauge'] }"
							type="Gauge"
							:data="ratio3ChartData"
							:options="ratio3ChartOptions"
						/>
						</v-row>
					</v-col>
				</v-row>
			</v-col>
		</v-row> -->
				<v-row no-gutters>
					<v-col cols="12" md="12" style="height: 300px">
						<GChart type="ComboChart" :data="mainChartData" :options="mainChartOptions" />
					</v-col>
				</v-row>
				<v-row v-if="data.variables.offset > data.rf" no-gutters>
					<v-col cols="12" md="6">
						<GChart type="ComboChart" :data="sec1ChartData" :options="sec1ChartOptions" />
					</v-col>
					<v-col cols="12" md="6">
						<GChart type="ComboChart" :data="sec2ChartData" :options="sec2ChartOptions" />
					</v-col>
				</v-row>
				<v-divider v-if="!clinic" class="my-4"></v-divider>
				<v-row no-gutters class="ml-10">
					<v-col>
						<template v-if="clinic">
							<b>M G</b>
						</template>
						<template v-else>
							<b>Média Geral</b>
							<br />(40 - 60)
						</template>
						<GChart
							:settings="{ packages: ['gauge'] }"
							type="Gauge"
							:data="ratio0aChartData"
							:options="ratio0aChartOptions"
						/>
					</v-col>
					<v-col>
						<template v-if="clinic">
							<b>I A E</b>
						</template>
						<template v-else>
							<b>Índice de Alteração Emocional</b>
							<br />(0 - 15)
						</template>
						<GChart
							:settings="{ packages: ['gauge'] }"
							type="Gauge"
							:data="ratio0bChartData"
							:options="ratio0bChartOptions"
						/>
					</v-col>
					<v-col>
						<template v-if="clinic">
							<b>R M-E</b>
						</template>
						<template v-else>
							<b>Razão Musculo-Esquelética</b>
							<br />(0.8 - 1.1)
						</template>
						<GChart
							:settings="{ packages: ['gauge'] }"
							type="Gauge"
							:data="ratio1ChartData"
							:options="ratio1ChartOptions"
						/>
						<template v-if="!clinic">
							<b>{{data.ratiotext['left/right'][0]}} ({{Math.round(data.ratios['left/right'] * 100) / 100}})</b>
							<br />
							{{data.ratiotext['left/right'][1]}}
						</template>
					</v-col>
					<v-col>
						<template v-if="clinic">
							<b>R M</b>
						</template>
						<template v-else>
							<b>Razão Metabólica</b>
							<br />(0.8 - 1.2)
						</template>
						<GChart
							:settings="{ packages: ['gauge'] }"
							type="Gauge"
							:data="ratio2ChartData"
							:options="ratio2ChartOptions"
						/>
						<template v-if="!clinic">
							<b>{{data.ratiotext['yin/yang'][0]}} ({{Math.round(data.ratios['yin/yang'] * 100) / 100}})</b>
							<br />
							{{data.ratiotext['yin/yang'][1]}}
						</template>
					</v-col>
					<v-col>
						<template v-if="clinic">
							<b>R C/M</b>
						</template>
						<template v-else>
							<b>Razão Cognitiva/Mental</b>
							<br />(0.9 - 1.2)
						</template>
						<GChart
							:settings="{ packages: ['gauge'] }"
							type="Gauge"
							:data="ratio3ChartData"
							:options="ratio3ChartOptions"
						/>
						<template v-if="!clinic">
							<b>{{data.ratiotext['top/bottom'][0]}} ({{Math.round(data.ratios['top/bottom'] * 100) / 100}})</b>
							<br />
							<div>{{data.ratiotext['top/bottom'][1]}}</div>
						</template>
					</v-col>
				</v-row>
				<!-- <v-divider class="my-4"></v-divider>
        <v-row no-gutters>
          <v-col cols="12" md="12">
            <GChart type="PieChart" :data="pieElemData" :options="pieElemOptions" />
          </v-col>
				</v-row>-->
				<template v-if="!clinic">
					<v-divider class="my-4"></v-divider>
					<v-btn icon @click="showResultsTable = !showResultsTable">
						<v-icon v-if="!showResultsTable" color="primary lighten-1">mdi-chevron-down</v-icon>
						<v-icon v-else color="primary lighten-1">mdi-chevron-up</v-icon>
					</v-btn>
					<v-row no-gutters v-if="showResultsTable">
						<v-col cols="12" md="12">
							<v-simple-table>
								<template v-slot:default>
									<thead>
										<tr>
											<th v-translate>Point</th>
											<th v-translate>LU</th>
											<th v-translate>PC</th>
											<th v-translate>HE</th>
											<th v-translate>SI</th>
											<th v-translate>SJ</th>
											<th v-translate>LI</th>
											<th v-translate>SP</th>
											<th v-translate>LIV</th>
											<th v-translate>KD</th>
											<th v-translate>BL</th>
											<th v-translate>GB</th>
											<th v-translate>ST</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<th class="text-left">Esq</th>
											<td>{{data.input.P[0]}}</td>
											<td>{{data.input.Pc[0]}}</td>
											<td>{{data.input.C[0]}}</td>
											<td>{{data.input.ID[0]}}</td>
											<td>{{data.input.SJ[0]}}</td>
											<td>{{data.input.IG[0]}}</td>
											<td>{{data.input.BP[0]}}</td>
											<td>{{data.input.F[0]}}</td>
											<td>{{data.input.R[0]}}</td>
											<td>{{data.input.Bx[0]}}</td>
											<td>{{data.input.VB[0]}}</td>
											<td>{{data.input.E[0]}}</td>
										</tr>
										<tr>
											<th class="text-left">Dir</th>
											<td>{{data.input.P[1]}}</td>
											<td>{{data.input.Pc[1]}}</td>
											<td>{{data.input.C[1]}}</td>
											<td>{{data.input.ID[1]}}</td>
											<td>{{data.input.SJ[1]}}</td>
											<td>{{data.input.IG[1]}}</td>
											<td>{{data.input.BP[1]}}</td>
											<td>{{data.input.F[1]}}</td>
											<td>{{data.input.R[1]}}</td>
											<td>{{data.input.Bx[1]}}</td>
											<td>{{data.input.VB[1]}}</td>
											<td>{{data.input.E[1]}}</td>
										</tr>
										<tr>
											<th class="text-left">Qualidade</th>
											<td>{{data.quality.P}}</td>
											<td>{{data.quality.Pc}}</td>
											<td>{{data.quality.C}}</td>
											<td>{{data.quality.ID}}</td>
											<td>{{data.quality.SJ}}</td>
											<td>{{data.quality.IG}}</td>
											<td>{{data.quality.BP}}</td>
											<td>{{data.quality.F}}</td>
											<td>{{data.quality.R}}</td>
											<td>{{data.quality.Bx}}</td>
											<td>{{data.quality.VB}}</td>
											<td>{{data.quality.E}}</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
					<p class="mt-4 text-subtitle-1 font-weight-medium" v-translate>Diagnosis</p>
					<v-row no-gutters class="mb-3">
						<p v-if="data.results.length == 0" class="font-weight-thin ml-2 text-body-2 grey--text" v-translate>No results.</p>
						<v-col v-else v-for="result in data.results" cols="6" :key="result.id">
							<v-row no-gutters align="center">
								<v-col cols="12">
									<span class="mx-1 font-weight-bold" v-for="(channel, i) in result.channels" :key="i + channel.channel">
										{{channel.channel.name}} - {{channel.quality.name}}
									</span>
								</v-col>
								<v-col v-if="result.note" cols="12">
									<span class="mx-1">{{result.note}}</span>
								</v-col>
								<v-col cols="12">
									<v-row no-gutters align="center" class="ml-2">
										<ICDList context="test-results" :list="result.icds" />
									</v-row>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</template>
	</div>
</template>

<script>
import { GChart } from "vue-google-charts";
import ICDList from "@/components/icd/ICDList.vue";

export default {
	name: "RyodorakuResults",
	props: ["data", "clinic", "showGCharts"],
	components: {
		GChart,
		ICDList
	},
	data: () => ({
		show: false,
		showResultsTable: false
	}),
	computed: {
		mainChartData() {
			var main_top_0 = this.data.deviations.main[0];
			var main_top_1 = this.data.deviations.main[1];
			var main_bottom_0 = this.data.deviations.main[0];
			var main_bottom_1 = this.data.deviations.main[1];

			if (this.data.variables.offset > this.data.rf) {
				main_top_0 = this.data.deviations.top_main[0];
				main_top_1 = this.data.deviations.top_main[1];
				main_bottom_0 = this.data.deviations.bottom_main[0];
				main_bottom_1 = this.data.deviations.bottom_main[1];
			}
			return [
				["Ponto", "Esq", "Dir", "Desvio+", "Desvio-"],
				[
					this.$gettext("LU"),
					this.data.resultGraph.P[0],
					this.data.resultGraph.P[1],
					main_top_0,
					main_top_1
				],
				[
					this.$gettext("PC"),
					this.data.resultGraph.Pc[0],
					this.data.resultGraph.Pc[1],
					main_top_0,
					main_top_1
				],
				[
					this.$gettext("HE"),
					this.data.resultGraph.C[0],
					this.data.resultGraph.C[1],
					main_top_0,
					main_top_1
				],
				[
					this.$gettext("SI"),
					this.data.resultGraph.ID[0],
					this.data.resultGraph.ID[1],
					main_top_0,
					main_top_1
				],
				[
					this.$gettext("SJ"),
					this.data.resultGraph.SJ[0],
					this.data.resultGraph.SJ[1],
					main_top_0,
					main_top_1
				],
				[
					this.$gettext("LI"),
					this.data.resultGraph.IG[0],
					this.data.resultGraph.IG[1],
					main_top_0,
					main_top_1
				],
				[
					this.$gettext("SP"),
					this.data.resultGraph.BP[0],
					this.data.resultGraph.BP[1],
					main_bottom_0,
					main_bottom_1
				],
				[
					this.$gettext("LIV"),
					this.data.resultGraph.F[0],
					this.data.resultGraph.F[1],
					main_bottom_0,
					main_bottom_1
				],
				[
					this.$gettext("KD"),
					this.data.resultGraph.R[0],
					this.data.resultGraph.R[1],
					main_bottom_0,
					main_bottom_1
				],
				[
					this.$gettext("BL"),
					this.data.resultGraph.Bx[0],
					this.data.resultGraph.Bx[1],
					main_bottom_0,
					main_bottom_1
				],
				[
					this.$gettext("GB"),
					this.data.resultGraph.VB[0],
					this.data.resultGraph.VB[1],
					main_bottom_0,
					main_bottom_1
				],
				[
					this.$gettext("ST"),
					this.data.resultGraph.E[0],
					this.data.resultGraph.E[1],
					main_bottom_0,
					main_bottom_1
				]
			];
		},
		mainChartOptions() {
			return {
				height: 300,
				seriesType: "bars",
				series: { 2: { type: "line" }, 3: { type: "line" } },
				colors: ["#2196F3", "#009688", "#FFD600", "#F44336"],
				legend: { position: "none" },
				//chartArea: { width: "90%", height: "40%" },
				vAxis: {
					viewWindow: {
						min: this.data.axis.main[0],
						max: this.data.axis.main[1]
					},
					gridlines: {
						count: 7
					}
				}
			};
		},
		sec1ChartData() {
			return [
				["Ponto", "Esq", "Dir", "Desvio+", "Desvio-"],
				[
					"P",
					this.data.resultOffset.P[0],
					this.data.resultOffset.P[1],
					this.data.deviations.top[0],
					this.data.deviations.top[1]
				],
				[
					"Pc",
					this.data.resultOffset.Pc[0],
					this.data.resultOffset.Pc[1],
					this.data.deviations.top[0],
					this.data.deviations.top[1]
				],
				[
					"C",
					this.data.resultOffset.C[0],
					this.data.resultOffset.C[1],
					this.data.deviations.top[0],
					this.data.deviations.top[1]
				],
				[
					"ID",
					this.data.resultOffset.ID[0],
					this.data.resultOffset.ID[1],
					this.data.deviations.top[0],
					this.data.deviations.top[1]
				],
				[
					"SJ",
					this.data.resultOffset.SJ[0],
					this.data.resultOffset.SJ[1],
					this.data.deviations.top[0],
					this.data.deviations.top[1]
				],
				[
					"IG",
					this.data.resultOffset.IG[0],
					this.data.resultOffset.IG[1],
					this.data.deviations.top[0],
					this.data.deviations.top[1]
				]
			];
		},
		sec1ChartOptions() {
			return {
				seriesType: "bars",
				series: { 2: { type: "line" }, 3: { type: "line" } },
				colors: ["#2196F3", "#009688", "#FFD600", "#F44336"],
				legend: { position: "none" },
				vAxis: {
					viewWindow: {
						min: this.data.axis.top[0],
						max: this.data.axis.top[1]
					},
					gridlines: {
						count: 7
					}
				}
			};
		},
		sec2ChartData() {
			return [
				["Ponto", "Esq", "Dir", "Desvio+", "Desvio-"],
				[
					"BP",
					this.data.resultOffset.BP[0],
					this.data.resultOffset.BP[1],
					this.data.deviations.bottom[0],
					this.data.deviations.bottom[1]
				],
				[
					"F",
					this.data.resultOffset.F[0],
					this.data.resultOffset.F[1],
					this.data.deviations.bottom[0],
					this.data.deviations.bottom[1]
				],
				[
					"R",
					this.data.resultOffset.R[0],
					this.data.resultOffset.R[1],
					this.data.deviations.bottom[0],
					this.data.deviations.bottom[1]
				],
				[
					"Bx",
					this.data.resultOffset.Bx[0],
					this.data.resultOffset.Bx[1],
					this.data.deviations.bottom[0],
					this.data.deviations.bottom[1]
				],
				[
					"VB",
					this.data.resultOffset.VB[0],
					this.data.resultOffset.VB[1],
					this.data.deviations.bottom[0],
					this.data.deviations.bottom[1]
				],
				[
					"E",
					this.data.resultOffset.E[0],
					this.data.resultOffset.E[1],
					this.data.deviations.bottom[0],
					this.data.deviations.bottom[1]
				]
			];
		},
		sec2ChartOptions() {
			return {
				seriesType: "bars",
				series: { 2: { type: "line" }, 3: { type: "line" } },
				colors: ["#2196F3", "#009688", "#FFD600", "#F44336"],
				legend: { position: "none" },
				vAxis: {
					viewWindow: {
						min: this.data.axis.bottom[0],
						max: this.data.axis.bottom[1]
					},
					gridlines: {
						count: 7
					}
				}
			};
		},
		ratio0aChartData() {
			return [
				["Lado", "Valor"],
				["40 - 100", Math.round(this.data.variables.average * 10) / 10]
			];
		},
		ratio0aChartOptions() {
			return {
				height: 120,
				min: 0,
				max: 100,
				greenColor: "#009688",
				greenFrom: 40,
				greenTo: 60
			};
		},
		ratio0bChartData() {
			return [
				["Lado", "Valor"],
				["0 - 15", Math.round(this.data.variables.offset * 10) / 10]
			];
		},
		ratio0bChartOptions() {
			return {
				height: 120,
				min: 0,
				max: 30,
				greenColor: "#009688",
				greenFrom: 0,
				greenTo: 15
			};
		},
		ratio1ChartData() {
			return [
				["Lado", "Valor"],
				["0.8 - 1.1", this.data.ratios["left/right"]]
			];
		},
		ratio1ChartOptions() {
			return {
				height: 120,
				min: 0.5,
				max: 1.5,
				greenColor: "#009688",
				greenFrom: 0.8,
				greenTo: 1.1
			};
		},
		ratio2ChartData() {
			return [
				["Lado", "Valor"],
				["0.8 - 1.2", this.data.ratios["yin/yang"]]
			];
		},
		ratio2ChartOptions() {
			return {
				height: 120,
				min: 0.5,
				max: 1.5,
				greenColor: "#009688",
				greenFrom: 0.8,
				greenTo: 1.2
			};
		},
		ratio3ChartData() {
			return [
				["Lado", "Valor"],
				["0.9 - 1.2", this.data.ratios["top/bottom"]]
			];
		},
		ratio3ChartOptions() {
			return {
				height: 120,
				min: 0.5,
				max: 1.5,
				greenColor: "#009688",
				greenFrom: 0.9,
				greenTo: 1.2
			};
		},
		pieElemData() {
			return [
				["Elemento", "Valor"],
				["Fogo (Mon)", this.data.elements.fireMon],
				["Fogo (Min)", this.data.elements.fireMin],
				["Terra", this.data.elements.earth],
				["Metal", this.data.elements.metal],
				["Água", this.data.elements.water],
				["Madeira", this.data.elements.wood]
			];
		},
		pieElemOptions() {
			return {
				colors: [
					"#D50000",
					"#F44336",
					"#FFD600",
					"#9E9E9E",
					"#2196F3",
					"#009688"
				],
				legend: { position: "right", alignment: "center" },
				chartArea: { width: "80%", height: "80%" }
			};
		}
	}
};
</script>